/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MetadataType } from './metadataType';
import type { ResourceMetadataContent } from './resourceMetadataContent';

/**
 * Metadata to a resource like transcript or summary
 */
export interface ResourceMetadata {
  type: MetadataType;
  version: string;
  content: ResourceMetadataContent;
  createdAt: string;
}
